import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import browser from "browser-detect";
import Bowser from "bowser";
import { useDispatch } from "react-redux";
import $ from "jquery";
import { useTranslation } from "react-i18next";
import { Country, State, City } from "country-state-city";
import logo from "../../assets/images/logo.svg";

// api
import { getGeoInfoData, login } from "../../api/users";

// lib
import { toastAlert } from "../../lib/toastAlert";
import isEmpty from "../../lib/isEmpty";

//import config
import config from "../../config/index";
const initialFormValue = {
  email: "",
  password: "",
  passwordIcon: false,
};

const LoginForm = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { t, i18n } = useTranslation();

  // state
  const [formValue, setFormValue] = useState(initialFormValue);
  const [loginHistory, setLoginHistory] = useState({});
  const [errors, setErrors] = useState({});
  const { email, password, passwordIcon } = formValue;
  const [loader, setLoader] = useState(false);

  //function
  const handleChange = (e) => {
    const { name, value, checked } = e.target;
    setFormValue({ ...formValue, ...{ [name]: value } });
    if (!isEmpty(errors)) {
      setErrors({});
    }
  };

  const handlePassIcon = (name) =>
    setFormValue({ ...formValue, ...{ [name]: !formValue[name] } });

  const handleSubmit = async (e) => {
    try {
      setLoader(true);
      const { status, loading, message, error } = await login(
        { email, password, loginHistory },
        dispatch,
      );
      setLoader(loading);
      if (status == "success") {
        setFormValue(initialFormValue);
        toastAlert("success", t(message), "signin", "TOP_CENTER");
        navigate("/wallet");
      } else {
        if (error) {
          setErrors(error);
          return false;
        }
        toastAlert("error", t(message), "signin", "TOP_CENTER");
      }
    } catch (err) {}
  };

  const getGeoInfo = async () => {
    const browserResult = browser();
    const Browser = Bowser.getParser(window.navigator.userAgent);
    try {
      let { result, status, error } = await getGeoInfoData(config.getGeoInfo);
      if (status === "success") {
        let countryData;
        const countryDetails = Country.getAllCountries();
        if (countryDetails.length > 0) {
          countryData = countryDetails.filter(
            (item) => item.isoCode === result?.country,
          )[0];
        }
        setLoginHistory({
          countryName: countryData?.name || "",
          countryCode: countryData?.phonecode || result?.country,
          ipAddress: result?.ip,
          regionName: result?.region,
          broswerName: `${Browser?.parsedResult?.browser?.name}${Browser?.parsedResult?.browser?.version}`,
          isMobile: browserResult?.mobile,
          os: Browser.parsedResult?.os?.name,
        });
      } else {
        const { result, status, error } = await getGeoInfoData(
          config.getGeoInfo_1,
        );
        if (status === "success") {
          setLoginHistory({
            countryName: result.country_name,
            countryCode: result.calling_code,
            ipAddress: result?.ip,
            regionName: `${result.district}, ${result.city}`,
            broswerName: `${Browser.parsedResult.browser.name}${Browser.parsedResult.browser.version}`,
            isMobile: browserResult.mobile,
            os: Browser.parsedResult.os.name,
          });
        } else {
          setLoginHistory({
            countryName: "",
            countryCode: "",
            ipAddress: "",
            reason: "Unable to fetch location",
            regionName: `${result.district}, ${result.city}`,
            broswerName: `${Browser.parsedResult.browser.name}${Browser.parsedResult.browser.version}`,
            isMobile: browserResult.mobile,
            os: Browser.parsedResult.os.name,
          });
        }
      }
    } catch (err) {
      try {
        const { result, status, error } = await getGeoInfoData(
          config.getGeoInfo_1,
        );
        if (status === "success") {
          setLoginHistory({
            countryName: result.country_name,
            countryCode: result.calling_code,
            ipAddress: result?.ip,
            regionName: `${result.district}, ${result.city}`,
            broswerName: `${Browser.parsedResult.browser.name}${Browser.parsedResult.browser.version}`,
            isMobile: browserResult.mobile,
            os: Browser.parsedResult.os.name,
          });
        } else {
          setLoginHistory({
            countryName: "",
            countryCode: "",
            ipAddress: "",
            reason: "Unable to fetch location",
            regionName: "",
            broswerName: `${Browser.parsedResult.browser.name}${Browser.parsedResult.browser.version}`,
            isMobile: browserResult.mobile,
            os: Browser.parsedResult.os.name,
          });
        }
      } catch (err) {
        setLoginHistory({
          countryName: "",
          countryCode: "",
          ipAddress: "",
          reason: "Unable to fetch location",
          regionName: "",
          broswerName: "",
          isMobile: browserResult.mobile,
          os: Browser.parsedResult.os.name,
        });
      }
    }
  };

  useEffect(() => {
    getGeoInfo();
  }, []);

  $(document).on("keypress", function (e) {
    if (e.which == 13) {
      e.preventDefault();
      handleSubmit(e);
    }
  });

  return (
    <>
      <div className="login_page_wrapper">
        <div className="login_split_container">
          {/* Left Side - Image (50%) */}
          <div className="login_image_half d-none d-lg-flex">
            <img
              src={require("../../assets/images/home/auth_bg.png")}
              alt="Professional Meeting"
              className="login_image_full"
            />
          </div>

          {/* Right Side - Form (50%) */}
          <div className="login_form_half">
            <div className="login_form_wrapper">
              {/* Logo Section */}
              <div className="login_logo_section">
                <Link className="" to="/">
                  <img
                    src={logo}
                    className="img-fluid brand_logo"
                    alt="Light logo"
                  />
                </Link>
              </div>

              {/* Login Title */}
              <h2 className="login_form_title">{t("LOGIN")}</h2>

              {/* Form */}
              <form className="login_form_fields">
                {/* Email Field */}
                <div className="form_field_group">
                  <label htmlFor="email" className="form_field_label">
                    {t("EMAIL")}
                  </label>
                  <input
                    type="email"
                    id="email"
                    name="email"
                    className="form_field_input"
                    placeholder={t("EMAIL_PLACEHOLDER")}
                    onChange={handleChange}
                    value={email}
                  />
                  {errors?.email && (
                    <span className="form_field_error">{t(errors?.email)}</span>
                  )}
                </div>

                {/* Password Field */}
                <div className="form_field_group">
                  <label htmlFor="password" className="form_field_label">
                    {t("PASSWORD")}
                  </label>
                  <div className="password_field_wrapper">
                    <input
                      type={!passwordIcon ? "password" : "text"}
                      id="password"
                      name="password"
                      className="form_field_input"
                      placeholder={t("PASSWORD_PLACEHOLDER")}
                      onChange={handleChange}
                      value={password}
                    />
                    <span
                      className="password_icon_toggle"
                      onClick={() => handlePassIcon("passwordIcon")}
                    >
                      <i
                        className={
                          passwordIcon
                            ? "bi bi-eye-fill"
                            : "bi bi-eye-slash-fill"
                        }
                      ></i>
                    </span>
                  </div>
                  {errors?.password && (
                    <span className="form_field_error">
                      {t(errors?.password)}
                    </span>
                  )}
                </div>

                {/* Checkbox and Forgot Password */}
                <div className="form_options_row">
                  <div className="form_checkbox_wrapper">
                    <input
                      type="checkbox"
                      id="keepLoggedIn"
                      className="form_checkbox_input"
                    />
                    <label
                      htmlFor="keepLoggedIn"
                      className="form_checkbox_label"
                    >
                      Keep me logged in
                    </label>
                  </div>
                  <Link to="/forgot-password" className="form_forgot_link">
                    {t("FORGOT_PASSWORD")}?
                  </Link>
                </div>

                {/* Login Button */}
                <button
                  type="button"
                  className="primary_btn"
                  onClick={handleSubmit}
                  disabled={loader}
                >
                  {loader && <i className="fas fa-spinner fa-spin"></i>}
                  <span>{t("LOGIN")}</span>
                </button>
              </form>

              {/* Sign Up Link */}
              <p className="form_signup_text">
                {t("DON'T_HAVE_ACCOUNT")}?{" "}
                <Link to="/register" className="form_signup_link">
                  {t("SIGN_UP")}
                </Link>
              </p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default LoginForm;
